import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppDataService } from "../../../_services/app_data.service";

@Component({
  standalone: false,
  selector: 'invoice-css-check-info',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './css-check.html'
})

export class InvoiceCssCheckComponent implements OnInit{
  constructor(
    public appDataService: AppDataService
  ) { }
  ngOnInit() { }
}
